"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DisposableQueue", {
  enumerable: true,
  get: function get() {
    return _disposableQueue.DisposableQueue;
  }
});
Object.defineProperty(exports, "IDisposable", {
  enumerable: true,
  get: function get() {
    return _disposable.IDisposable;
  }
});
Object.defineProperty(exports, "timeout", {
  enumerable: true,
  get: function get() {
    return _timeoutPromise.timeout;
  }
});
var _disposableQueue = require("./disposable-queue");
var _disposable = require("./disposable");
var _timeoutPromise = require("./timeout-promise");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IERpc3Bvc2FibGVRdWV1ZSB9IGZyb20gJy4vZGlzcG9zYWJsZS1xdWV1ZSc7XG5pbXBvcnQgeyBJRGlzcG9zYWJsZSB9IGZyb20gJy4vZGlzcG9zYWJsZSc7XG5pbXBvcnQgeyB0aW1lb3V0IH0gZnJvbSAnLi90aW1lb3V0LXByb21pc2UnO1xuXG5leHBvcnQgeyBJRGlzcG9zYWJsZSwgRGlzcG9zYWJsZVF1ZXVlLCB0aW1lb3V0IH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7QUFDQTtBQUNBIn0=